var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcCamera = function SvgIcCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "ic_camera_svg__st0",
    cx: 12,
    cy: 12,
    r: 12
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.1 8.2H12c1.2 0 2.1.8 2.1 2v3.4c0 1.2-.8 2-2.1 2H9.1c-1.2 0-2.1-.8-2.1-2v-3.4c0-1.1.8-2 2.1-2zM16 9.4c.2-.1.5-.1.7 0 .2.1.3.4.3.6v3.8c0 .3-.1.5-.3.6-.1.1-.2.1-.4.1-.1 0-.2 0-.3-.1l-.7-.4c-.3-.1-.4-.4-.4-.7v-2.9c0-.3.2-.6.4-.7l.7-.3z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }));
};
export default SvgIcCamera;